import styled from "styled-components";
import { Card, Typography } from "antd";
import colors from "constants/colors";

const { Title, Paragraph } = Typography;

export const StyledCard = styled(Card)`
  height: 100px;
  width: 350px;
  position: relative;
  background: transparent;
  border: none;
`;

export const StyledImage = styled.img`
  width: 100px;
  height: 100px;
  border-radius: 10px;
  object-fit: cover;
`;

export const StyledTitleMemberName = styled(Title)`
  overflow-wrap: break-word;
  white-space: normal;
  padding-top: 0.5em;
  width: auto;
  line-height: 130% !important;
`;

export const StyledParagraphMemberRole = styled(Paragraph)`
  line-height: 1;
  margin-bottom: 0;
  font-size: 1em;
`;

export const StyledParagraphMemberContact = styled(Paragraph)`
  font-size: 0.9em;
  color: ${colors.primary};
  a {
    :hover {
      color: ${colors.blue};
    }
  }
`;
